import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  AccordionDetails,
  AccordionSummary,
  alpha,
  Accordion as MuiAccordion,
} from "@mui/material";
import Container from "@mui/material/Container";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import _ from "lodash";
import Markdown from 'react-markdown'

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.primary.main}`,
  backgroundColor: alpha(theme.palette.primary.main, 0.05),
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
  "&:first-of-type": {
    borderTopRightRadius: 8,
    borderTopLeftRadius: 8,
  },
  "&:last-of-type": {
    borderBottomRightRadius: 8,
    borderBottomLeftRadius: 8,
  },
}));

function FAQs({ data = []}) {
  return _.size(data) ? (
    <Container id="faqs" maxWidth="lg" sx={{ paddingY: 5 }}>
      <Typography variant="h3" marginBottom={3}>
        FAQs
      </Typography>
      {_.map(data, (item, index) => (
        <Accordion key={item.question} defaultExpanded={!index}>
          <AccordionSummary expandIcon={<ExpandMoreIcon color="primary" />}>
            <Typography fontWeight="bold" color="primary">
              {item.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body">
              <Markdown>
                {item.answer}
              </Markdown>
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Container>
  ) : null;
}

export default FAQs;
